import { IAccountUser } from '../models/account-user';
import { EMPTY_GUID } from '../models/common';
import { ICompanyAccount } from '../models/company-account';
import { IBucket } from '../models/prostatic';
import { IResult } from '../models/result-models';
import { IRole } from '../models/role';
import { API_BASE_URL, apiGet } from './api-utils';
const baseUrl = API_BASE_URL + '/v1/companies/';

export const getCompanyRoles = async (
    id?: string
): Promise<IResult<IRole[]>> => {
    const uid = id || EMPTY_GUID;
    const url = baseUrl + uid + '/roles';
    const result = await apiGet<IRole[]>(url);

    return result;
};

export const getCompanyAccounts = async (
    id?: string
): Promise<IResult<ICompanyAccount[]>> => {
    const uid = id || EMPTY_GUID;
    const url = baseUrl + uid + '/accounts';
    const result = await apiGet<ICompanyAccount[]>(url);

    return result;
};

export const getCompanyBuckets = async (
    id?: string
): Promise<IResult<IBucket[]>> => {
    const uid = id || EMPTY_GUID;
    const url = baseUrl + uid + '/buckets';
    const result = await apiGet<IBucket[]>(url);

    return result;
};

export const getCompanyAccountUsers = async (
    id?: string
): Promise<IResult<IAccountUser[]>> => {
    const uid = id || EMPTY_GUID;
    const url = baseUrl + uid + '/account-users';
    const result = await apiGet<IAccountUser[]>(url);

    return result;
};

export const getCompanyAccountContacts = async (
    id?: string
): Promise<IResult<IAccountUser[]>> => {
    const uid = id || EMPTY_GUID;
    const url = baseUrl + uid + '/order-preferences/account-contacts';
    const result = await apiGet<IAccountUser[]>(url);

    return result;
};
